import { render, staticRenderFns } from "./SettingsItem.vue?vue&type=template&id=16398ef8&lang=pug&"
import script from "./SettingsItem.vue?vue&type=script&lang=js&"
export * from "./SettingsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports